import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a586ef90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sad-modal" }
const _hoisted_2 = {
  key: 0,
  class: "sad-modal__wrapper",
  role: "dialog"
}
const _hoisted_3 = { class: "sad-modal__header" }
const _hoisted_4 = {
  key: 0,
  class: "sad-modal__header-title",
  "data-test": "title"
}
const _hoisted_5 = { class: "sad-modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sad_icon = _resolveComponent("sad-icon")!
  const _component_sad_button = _resolveComponent("sad-button")!
  const _component_focus_trap = _resolveComponent("focus-trap")!

  return (_openBlock(), _createBlock(_component_focus_trap, { active: _ctx.show }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.show)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "sad-modal__overlay",
                  "data-test": "overlay",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "fade-up" }, {
          default: _withCtx(() => [
            (_ctx.show)
              ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                  _createElementVNode("header", _hoisted_3, [
                    _createVNode(_component_sad_button, {
                      type: "ghost",
                      size: "small",
                      "aria-label": _ctx.t('general.closeRegion', { title: _ctx.title }),
                      "data-test": "close-btn",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_sad_icon, {
                          name: "times",
                          size: "medium"
                        })
                      ]),
                      _: 1
                    }, 8, ["aria-label"]),
                    (_ctx.title)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_ctx.title), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true),
                  _createElementVNode("footer", _hoisted_5, [
                    _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 3
        })
      ])
    ]),
    _: 3
  }, 8, ["active"]))
}